<template>
  <div id="app">
    <!-- <HelloWorld msg="Welcome to Your Vue.js App" /> -->
    <Header v-if="!$route.meta.customHeader" />
    <router-view />
    <Footer v-if="!$route.meta.customFooter" />
  </div>
</template>

<script>
// import HelloWorld from "./components/HelloWorld.vue";
import Header from "./components/Header.vue";
import Footer from "./components/Footer.vue";
import { getWebsite } from "../src/api/userApi";
export default {
  name: "App",
  components: {
    // HelloWorld,
    Header,
    Footer,
  },
  data() {
    return {
      websiteInfo: {
        favicon: "",
        title: "",
        description: "",
        keywords: "",
      },
    };
  },
  async created() {
    // 获取用户信息
    this.getWebsite();
  },
  methods: {
    async getWebsite() {
      try {
        const response = await getWebsite();
        console.log(response.data);
        if (response.code === 1) {
          this.websiteInfo = {
            favicon: response.data.favicon,
            title: response.data.title,
            description: response.data.description,
            keywords: response.data.keywords,
          };
          // 更新网页元信息
          this.updateMetaInfo();
        }
      } catch (error) {
        console.error("获取接口失败", error);
      }
    },
    updateMetaInfo() {
      // 更新标题
      document.title = this.websiteInfo.title;

      // 更新或创建description meta
      this.updateMetaTag("description", this.websiteInfo.description);

      // 更新或创建keywords meta
      this.updateMetaTag("keywords", this.websiteInfo.keywords);

      // 更新favicon
      this.updateFavicon(this.websiteInfo.favicon);
    },

    updateMetaTag(name, content) {
      let tag = document.querySelector(`meta[name="${name}"]`);
      if (!tag) {
        tag = document.createElement("meta");
        tag.name = name;
        document.head.appendChild(tag);
      }
      tag.content = content;
    },

    updateFavicon(href) {
      if (!href) return;

      let link =
        document.querySelector("link[rel*='icon']") ||
        document.createElement("link");
      link.type = "image/x-icon";
      link.rel = "shortcut icon";
      link.href = href;
      document.head.appendChild(link);
    },
  },
};
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

ul li {
  list-style: none;
}

a {
  text-decoration: none;
}
</style>
